import React from 'react';

const LogEntriesDetailModal = ({ isOpen, onClose, logEntry }) => {
    if (!isOpen) return null;

    console.log(logEntry);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-3xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Log Entry Details</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    {/* Log Details Section */}
                    <div className="mb-6">
                        <h3 className="text-2xl font-bold">Log ID: {logEntry.id}</h3>
                        <div><strong>Level: </strong> {logEntry.level}</div>
                        <div><strong>Message: </strong> {logEntry.message}</div>
                        <div><strong>Status Code: </strong> {logEntry.status_code}</div>
                        <div><strong>Endpoint: </strong> {logEntry.endpoint}</div>
                        <div><strong>Method: </strong> {logEntry.method}</div>
                    </div>

                    {/* Stack Trace Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Stack Trace</h4>
                        <pre className="bg-gray-100 p-4 rounded-md overflow-auto">{logEntry.stack_trace || "NA"}</pre>
                    </div>

                    {/* Request Details Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Request & User Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>User Email: </strong> {logEntry.user_email || "NA"}</div>
                            <div><strong>User IP: </strong> {logEntry.user_ip || "NA"}</div>
                            <div><strong>User Agent: </strong> {logEntry.user_agent || "NA"}</div>
                            <div><strong>Session ID: </strong> {logEntry.session_id || "NA"}</div>
                        </div>
                    </div>

                    {/* Additional Info Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Additional Information</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Error Type: </strong> {logEntry.error_type || "NA"}</div>
                            <div><strong>Function Name: </strong> {logEntry.function_name || "NA"}</div>
                            <div><strong>Module Name: </strong> {logEntry.module_name || "NA"}</div>
                            <div><strong>Task Name: </strong> {logEntry.task_name || "NA"}</div>
                            <div><strong>Custom Message: </strong> {logEntry.custom_message || "NA"}</div>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogEntriesDetailModal;
